import { createAsyncThunk } from '@reduxjs/toolkit';

import { ConfiguracaoPortalService } from '../../common/services/configuracaoPortal';
import { PersonalizacaoService } from '../../common/services/personalizacao';
import { RequerimentoService } from '../../common/services/requerimento';
import { initialState } from './initialState';

export const getMenuAtendimentoVirtual = createAsyncThunk(
  'configs/getMenuAtendimentoVirtual',
  async ({ plano, sitPart, tipoBeneficio }, { rejectWithValue }) => {
    try {
      const personalizacaoService = new PersonalizacaoService();

      const menu = await personalizacaoService.getMenuAtendimentoVirtual(
        plano,
        sitPart,
        tipoBeneficio
      );

      return menu;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getTelasDisponiveis = createAsyncThunk(
  'configs/getTelasDisponiveis',
  async ({ plano, sitPart, tipoBeneficio }, { rejectWithValue }) => {
    try {
      const personalizacaoService = new PersonalizacaoService();

      const telasDisponiveis = await personalizacaoService.getTelasPorPerfil(
        plano,
        sitPart,
        tipoBeneficio
      );

      return telasDisponiveis;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getPersonalizacao = createAsyncThunk(
  'configs/getPersonalizacao',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { matricula, token, plano } = getState().user.data;
      const personalizacaoService = new PersonalizacaoService();

      const personalizacao = await personalizacaoService.getPersonalizacaoHome(
        matricula,
        token,
        plano
      );

      if (Object.keys(personalizacao).length === 0 || personalizacao === '[]') {
        return initialState.personalizacao.data;
      }

      return personalizacao;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const setPersonalizacao = createAsyncThunk(
  'configs/setPersonalizacao',
  async (preferencias, { rejectWithValue, getState }) => {
    try {
      const { matricula, token, plano } = getState().user.data;
      const personalizacaoService = new PersonalizacaoService();

      const result = await personalizacaoService.setPersonalizacaoHome(
        matricula,
        plano,
        preferencias,
        token
      );

      if (result === 1) {
        const personalizacao =
          await personalizacaoService.getPersonalizacaoHome(
            matricula,
            token,
            plano
          );

        return personalizacao;
      }

      return rejectWithValue('Falha ao salvar personalização da home.');
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getListagemRequerimentos = createAsyncThunk(
  'configs/getListagemRequerimentos',
  async (_, { rejectWithValue }) => {
    try {
      const requerimentosService = new RequerimentoService();

      const requerimentos =
        await requerimentosService.obterTitulosFormularios();

      const requerimentosFormatado = requerimentos.map((item) => ({
        id: item.Id,
        nome: item.Title,
        referencia: item.Referencia,
        apelido: item.Apelido,
        descricao: item.Descricao,
        navegacao: item.Navegacao,
      }));

      return requerimentosFormatado;
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);

export const getDataCorte = createAsyncThunk(
  'configs/getDataCorte',
  async (_, { rejectWithValue }) => {
    try {
      const configPortalServices = new ConfiguracaoPortalService();

      const corteExtratoResponse =
        await configPortalServices.getConfiguracaoesPortal(
          'Data Corte - Extrato'
        );
      const corteContrachequeResponse =
        await configPortalServices.getConfiguracaoesPortal(
          'Data Corte - Contracheque'
        );

      const corteExtrato =
        corteExtratoResponse.data.results[0].Valor.split('/');
      const corteContracheque =
        corteContrachequeResponse.data.results[0].Valor.split('/');

      return { corteExtrato, corteContracheque };
    } catch (error) {
      return rejectWithValue('Erro inesperado. Tente novamente mais tarde.');
    }
  }
);
